import { DailyAgendaActionFactory } from '../actions';

export type OnDialogCloseAction = () => Promise<void>;

export const createOnDialogCloseAction: DailyAgendaActionFactory<
  OnDialogCloseAction
> = ({ setState, getState }) => {
  return async () => {
    const { dialog } = getState();
    if (!dialog) {
      return;
    }
    setState({
      dialog: undefined,
    });
  };
};
